export default __webpack_public_path__ + "static/work-d5c1d60952f9e28d865ae9641aa6ace2.webp";